/**
 * Vista: Detalle/Nuevo Pedido / Orden de Compra
 * UX: Formulario único arriba + tabla de tractores abajo
 */

import api from '../services/api.js';
import modeloService from '../services/modelo.service.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';

export default {
  data: {
    pedido: null,
    isNew: false,
    proveedores: []
  },

  // Array interno de tractores agregados
  _tractores: [],
  _editingIndex: null, // null = agregando nuevo, number = editando existente
  _almacenes: null,
  _almacenesCount: 0,

  async render(params) {
    this.data.isNew = !params.id || params.id === 'nuevo';

    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
          <h2 class="card-title">${this.data.isNew ? 'Nueva Orden de Compra' : 'Orden de Compra'}</h2>
          <div id="headerActions" style="display: flex; gap: 0.5rem;">
            <button class="btn btn-secondary" onclick="router.navigate('/compras/pedidos')">
              &larr; Volver
            </button>
            ${!this.data.isNew && params?.id && permisos.canPrint('ordenes_compra') ? `
              <button class="btn btn-primary" onclick="window.pedidoDetalleView.imprimir()">
                🖨️ Imprimir
              </button>
            ` : ''}
          </div>
        </div>

        <div id="pedidoContent">
          <div style="text-align: center; padding: 2rem;">Cargando...</div>
        </div>
      </div>
    `;
  },

  async afterRender(params) {
    window.pedidoDetalleView = this;
    this._tractores = [];
    this._editingIndex = null;

    if (this.data.isNew) {
      await this.cargarCatalogos();
      this.renderFormularioNuevo();
    } else {
      await this.cargarPedido(params.id);
    }
  },

  async cargarCatalogos() {
    try {
      const provRes = await api.get('/proveedores/activos').catch(() => ({ data: { proveedores: [] } }));
      this.data.proveedores = provRes.data?.proveedores || [];
    } catch (error) {
      console.error('Error al cargar catálogos:', error);
    }
  },

  async cargarPedido(id) {
    try {
      const response = await api.get(`/pedidos-compra/${id}`);
      this.data.pedido = response.data?.pedido || response.pedido || response.data;

      if (this.data.pedido) {
        await this.renderPedidoExistente();
      }
    } catch (error) {
      toast.error('Error al cargar pedido');
      console.error(error);
      router.navigate('/compras/pedidos');
    }
  },

  _sectionTitle(title) {
    return `<h4 style="margin: 0 0 1rem; font-size: 0.8rem; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; color: var(--primary); display: flex; align-items: center; gap: 0.75rem;">${title}<span style="flex: 1; height: 2px; background: var(--gray-200);"></span></h4>`;
  },

  _labelStyle() {
    return 'font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-500); margin-bottom: 0.25rem; display: block;';
  },

  // ─── FORMULARIO NUEVO ────────────────────────────────────
  renderFormularioNuevo() {
    const container = document.getElementById('pedidoContent');

    container.innerHTML = `
      <form id="formPedido" novalidate>
        <!-- Datos del Pedido -->
        <div style="border: 1px solid var(--gray-200); border-radius: 8px; padding: 1.25rem; margin-bottom: 1.5rem;">
          ${this._sectionTitle('Datos de Orden')}
          <div class="ped-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem;">
            <div>
              <label style="${this._labelStyle()}">Proveedor *</label>
              <select name="proveedor_id" class="form-select" required>
                <option value="">Seleccione proveedor...</option>
                ${this.data.proveedores.map(p => `
                  <option value="${p.id}" data-moneda="${p.moneda || 'MXN'}">${p.nombre}</option>
                `).join('')}
              </select>
            </div>
            <div>
              <label style="${this._labelStyle()}">Moneda</label>
              <input type="text" name="moneda" class="form-input" readonly
                style="background: var(--gray-50); cursor: not-allowed;"
                value="" placeholder="Selecciona un proveedor" />
            </div>
          </div>
        </div>

        <!-- Botón agregar tractor + Tabla -->
        <div id="tablaTractoresSection" style="margin-bottom: 1.5rem;">
          ${this._renderTablaTractores()}
        </div>

        <!-- Footer total + botones -->
        <div class="ped-footer-acciones" style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 1rem;">
          <div id="totalGeneralPedido" style="background: #E6F1FB; color: var(--primary); padding: 0.5rem 1rem; border-radius: 8px; font-size: 0.9rem; font-weight: 600;">
            Total est.: $0.00 USD
          </div>
          <div style="display: flex; gap: 0.75rem;">
            <button type="button" class="btn btn-secondary" onclick="router.navigate('/compras/pedidos')">Cancelar</button>
            <button type="button" class="btn btn-primary" onclick="window.pedidoDetalleView.guardarNuevo()">Guardar orden</button>
          </div>
        </div>
      </form>
    `;

    this._cargarAlmacenes();

    // Moneda se hereda del proveedor (readonly). Al cambiar el proveedor, se
    // actualiza automáticamente.
    const proveedorSelect = document.querySelector('[name="proveedor_id"]');
    const monedaInput = document.querySelector('[name="moneda"]');
    if (proveedorSelect && monedaInput) {
      proveedorSelect.addEventListener('change', (e) => {
        const option = e.target.options[e.target.selectedIndex];
        const moneda = option?.dataset?.moneda || '';
        monedaInput.value = moneda;
        this._actualizarTotalGeneral();
        if (this._tractores.length > 0) this._refreshTabla();
      });
    }
  },

  // ─── MODAL DE TRACTOR (WIZARD 2 PASOS) ────────────────────
  _abrirModalTractor(index = null) {
    this._editingIndex = index;
    this._wizardStep = 1;
    const isEdit = index !== null;
    const t = isEdit ? this._tractores[index] : null;
    const moneda = document.querySelector('[name="moneda"]')?.value || 'USD';
    const ls = this._labelStyle();

    const html = `
      <div>
        <!-- Indicador de pasos -->
        <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 1.25rem;">
          <div id="wizardStep1Indicator" style="display: flex; align-items: center; gap: 0.4rem;">
            <span id="wizardStep1Badge" style="width: 26px; height: 26px; border-radius: 50%; background: var(--primary); color: white; display: flex; align-items: center; justify-content: center; font-size: 0.75rem; font-weight: 700;">1</span>
            <span id="wizardStep1Label" style="font-size: 0.8rem; font-weight: 600; color: var(--primary);">Datos</span>
          </div>
          <div style="flex: 1; height: 2px; background: var(--gray-200); margin: 0 0.25rem;"><div id="wizardStepLine" style="height: 100%; width: 0%; background: var(--primary); transition: width 0.3s;"></div></div>
          <div id="wizardStep2Indicator" style="display: flex; align-items: center; gap: 0.4rem;">
            <span id="wizardStep2Badge" style="width: 26px; height: 26px; border-radius: 50%; background: var(--gray-200); color: var(--gray-500); display: flex; align-items: center; justify-content: center; font-size: 0.75rem; font-weight: 700;">2</span>
            <span id="wizardStep2Label" style="font-size: 0.8rem; font-weight: 500; color: var(--gray-400);">Almacenes</span>
          </div>
        </div>

        <!-- PASO 1: Datos del equipo -->
        <div id="wizardPaso1">
          <div class="ped-grid-2col" style="display: grid; grid-template-columns: 1fr 1fr; gap: 0.5rem;">
            <div>
              <label style="${ls}">Marca *</label>
              <select name="detalle_marca_f" id="marca_f" class="form-select" required>
                <option value="">— Selecciona —</option>
              </select>
            </div>
            <div>
              <label style="${ls}">Modelo *</label>
              <select name="detalle_modelo_f" id="modelo_f" class="form-select" required disabled>
                <option value="">— Selecciona marca primero —</option>
              </select>
            </div>
          </div>
          <div class="ped-grid-2col" style="display: grid; grid-template-columns: 1fr 1fr; gap: 0.5rem; margin-top: 0.5rem;">
            <div>
              <label style="${ls}">Año</label>
              <input type="number" name="detalle_anio_f" class="form-input" value="${new Date().getFullYear()}" readonly style="background: #f3f4f6; cursor: not-allowed;" />
            </div>
            <div>
              <label style="${ls}">Nombre Invoice</label>
              <input type="text" name="detalle_invoice_f" class="form-input" placeholder="INV-2026-001" />
            </div>
          </div>
          <div class="ped-grid-2col" style="display: grid; grid-template-columns: 1fr 1fr; gap: 0.5rem; margin-top: 0.5rem;">
            <div>
              <label style="${ls}">Cantidad *</label>
              <input type="number" name="detalle_cantidad_f" class="form-input" value="1" min="1" required style="text-align: center;" onchange="window.pedidoDetalleView._onFormCantidadChange()" />
            </div>
            <div>
              <label style="${ls}" id="labelPrecio_f">Precio Unit. (${moneda}) *</label>
              <input type="number" name="detalle_costo_f" id="costo_f" class="form-input" step="0.01" min="0" placeholder="0.00" />
            </div>
          </div>
          <div style="margin-top: 0.5rem;">
            <label style="${ls}">Observaciones</label>
            <input type="text" name="detalle_obs_f" class="form-input" placeholder="Notas del equipo..." />
          </div>
        </div>

        <!-- PASO 2: Distribución por almacén -->
        <div id="wizardPaso2" style="display: none;">
          <div id="wizardPaso2Resumen" style="display: none;"></div>

          <!-- Encabezado tabla almacenes -->
          <div class="ped-alm-header" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.5rem;">
            <div class="ped-alm-columns" style="display: grid; grid-template-columns: 30px 1fr 1fr 40px; gap: 0.5rem; flex: 1; padding: 0.5rem 0.25rem; border-bottom: 2px solid var(--gray-200);">
              <span style="font-size: 0.7rem; font-weight: 600; text-transform: uppercase; color: var(--gray-500);">#</span>
              <span style="font-size: 0.7rem; font-weight: 600; text-transform: uppercase; color: var(--gray-500);">Almacén</span>
              <span style="font-size: 0.7rem; font-weight: 600; text-transform: uppercase; color: var(--gray-500); text-align: center;">Cantidad</span>
              <span></span>
            </div>
            <button type="button" id="btnAgregarAlmacen_f" onclick="window.pedidoDetalleView._agregarAlmacenForm()" style="font-size: 0.8rem; border: 1px solid var(--gray-300); background: white; padding: 0.35rem 0.75rem; border-radius: 8px; cursor: pointer; color: var(--gray-700); font-weight: 600; white-space: nowrap; margin-left: 0.75rem; transition: border-color 0.2s, color 0.2s;" onmouseover="this.style.borderColor='var(--primary)'; this.style.color='var(--primary)';" onmouseout="this.style.borderColor='var(--gray-300)'; this.style.color='var(--gray-700)';">+ Agregar</button>
          </div>

          <div id="almacenes_f" class="ped-dist-body"></div>

          <!-- Progreso -->
          <div style="display: flex; justify-content: flex-end; margin-top: 0.75rem; padding-top: 0.5rem; border-top: 1px solid var(--gray-200);">
            <span id="almacenCounter_f" style="font-size: 0.8rem; font-weight: 600; color: var(--gray-600);">0 / 1</span>
          </div>
          <div id="almacenProgress_f" style="margin-top: 0.5rem;">
            <div style="height: 4px; background: var(--gray-200); border-radius: 2px; overflow: hidden;">
              <div id="almacenBar_f" style="height: 100%; width: 0%; background: var(--success); border-radius: 2px; transition: width 0.3s;"></div>
            </div>
          </div>
          <div id="almacenWarning_f" style="display: none; font-size: 0.8rem; margin-top: 0.5rem; padding: 0.5rem 0.75rem; border-radius: 6px;"></div>
        </div>
      </div>
    `;

    const title = isEdit ? `<span style="color: var(--primary);">Editar equipo:</span> ${t.marca} · ${t.modelo}` : '<span style="color: var(--primary);">Agregar equipo</span>';

    modal.open(title, html, [
      { text: 'Cancelar', class: 'btn-secondary', onClick: () => {} },
      {
        text: '← Atrás',
        class: 'btn-secondary',
        onClick: () => this._wizardAtras(),
        closeOnClick: false
      },
      {
        text: 'Siguiente →',
        class: 'btn-primary',
        onClick: () => this._wizardSiguiente(),
        closeOnClick: false
      }
    ]);

    // Ocultar botón "Atrás" en paso 1
    this._actualizarBotonesWizard();

    setTimeout(async () => {
      await this._setupFormTractor();

      if (isEdit) {
        await this._cargarDatosEnForm(t);
      }
    }, 50);
  },

  _wizardSiguiente() {
    if (this._wizardStep === 1) {
      // Validar paso 1
      const marca = document.getElementById('marca_f')?.value;
      const modelo = document.getElementById('modelo_f')?.value;
      if (!marca) { toast.error('Debe seleccionar una marca'); return; }
      if (!modelo) { toast.error('Debe seleccionar un modelo'); return; }

      const cantidad = parseInt(document.querySelector('[name="detalle_cantidad_f"]')?.value) || 1;
      const precioUnit = parseFloat(document.getElementById('costo_f')?.value) || 0;
      if (precioUnit <= 0) { toast.error('Debe ingresar el precio unitario'); return; }

      // Mostrar resumen en paso 2
      const resumen = document.getElementById('wizardPaso2Resumen');
      if (resumen) {
        const invoice = document.querySelector('[name="detalle_invoice_f"]')?.value || '';
        resumen.innerHTML = `
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <div>
              <div style="font-weight: 700; color: var(--gray-800);">${marca} · ${modelo}</div>
              ${invoice ? `<div style="font-size: 0.8rem; color: var(--gray-400);">${invoice}</div>` : ''}
            </div>
            <span style="font-size: 0.8rem; color: var(--primary); font-weight: 600;">× ${cantidad} ${cantidad === 1 ? 'unidad' : 'unidades'}</span>
          </div>`;
      }

      // Inicializar almacenes si es la primera vez
      const almContainer = document.getElementById('almacenes_f');
      if (almContainer && almContainer.children.length === 0) {
        this._almacenesCount = 0;
        this._agregarAlmacenForm(true);
      }
      this._validarDistribucionForm();

      this._wizardStep = 2;
      document.getElementById('wizardPaso1').style.display = 'none';
      document.getElementById('wizardPaso2').style.display = 'block';
      this._actualizarIndicadorWizard();
      this._actualizarBotonesWizard();
    } else if (this._wizardStep === 2) {
      // Guardar
      this._agregarALista();
    }
  },

  _wizardAtras() {
    if (this._wizardStep === 2) {
      this._wizardStep = 1;
      document.getElementById('wizardPaso1').style.display = 'block';
      document.getElementById('wizardPaso2').style.display = 'none';
      this._actualizarIndicadorWizard();
      this._actualizarBotonesWizard();
    }
  },

  _actualizarIndicadorWizard() {
    const step = this._wizardStep;
    const badge1 = document.getElementById('wizardStep1Badge');
    const label1 = document.getElementById('wizardStep1Label');
    const badge2 = document.getElementById('wizardStep2Badge');
    const label2 = document.getElementById('wizardStep2Label');
    const line = document.getElementById('wizardStepLine');

    if (step === 1) {
      if (badge1) { badge1.style.background = 'var(--primary)'; badge1.style.color = 'white'; }
      if (label1) { label1.style.color = 'var(--primary)'; label1.style.fontWeight = '600'; }
      if (badge2) { badge2.style.background = 'var(--gray-200)'; badge2.style.color = 'var(--gray-500)'; }
      if (label2) { label2.style.color = 'var(--gray-400)'; label2.style.fontWeight = '500'; }
      if (line) line.style.width = '0%';
    } else {
      if (badge1) { badge1.style.background = 'var(--success)'; badge1.style.color = 'white'; badge1.textContent = '✓'; }
      if (label1) { label1.style.color = 'var(--success)'; }
      if (badge2) { badge2.style.background = 'var(--primary)'; badge2.style.color = 'white'; }
      if (label2) { label2.style.color = 'var(--primary)'; label2.style.fontWeight = '600'; }
      if (line) line.style.width = '100%';
    }
  },

  _actualizarBotonesWizard() {
    const footer = document.querySelector('.modal-footer');
    if (!footer) return;
    const buttons = footer.querySelectorAll('button');
    // buttons: [Cancelar, Atrás, Siguiente/Guardar]
    if (buttons.length < 3) return;

    const btnAtras = buttons[1];
    const btnSiguiente = buttons[2];
    const isEdit = this._editingIndex !== null;

    if (this._wizardStep === 1) {
      btnAtras.style.display = 'none';
      btnSiguiente.textContent = 'Siguiente →';
    } else {
      btnAtras.style.display = 'inline-block';
      btnSiguiente.textContent = isEdit ? 'Guardar cambios' : 'Agregar';
    }
  },

  async _cargarDatosEnForm(t) {
    const marcaSelect = document.getElementById('marca_f');
    if (marcaSelect) {
      marcaSelect.value = t.marca;
      marcaSelect.dispatchEvent(new Event('change'));
    }

    await new Promise(r => setTimeout(r, 300));

    const modeloSelect = document.getElementById('modelo_f');
    if (modeloSelect) modeloSelect.value = t.modelo;

    const anioInput = document.querySelector('[name="detalle_anio_f"]');
    if (anioInput) anioInput.value = t.anio || new Date().getFullYear();

    const invoiceInput = document.querySelector('[name="detalle_invoice_f"]');
    if (invoiceInput) invoiceInput.value = t.nombre_invoice || '';

    const obsInput = document.querySelector('[name="detalle_obs_f"]');
    if (obsInput) obsInput.value = t.observaciones || '';

    const cantInput = document.querySelector('[name="detalle_cantidad_f"]');
    if (cantInput) cantInput.value = t.cantidad || 1;

    const precioInput = document.getElementById('costo_f');
    if (precioInput) precioInput.value = t.precio_unitario || '';

    // Bloquear marca y modelo en edición
    const marcaEl = document.getElementById('marca_f');
    const modeloEl = document.getElementById('modelo_f');
    if (marcaEl) { marcaEl.disabled = true; marcaEl.style.background = 'var(--gray-50)'; }
    if (modeloEl) { modeloEl.disabled = true; modeloEl.style.background = 'var(--gray-50)'; }

    // Almacenes
    const almContainer = document.getElementById('almacenes_f');
    if (almContainer) almContainer.innerHTML = '';
    this._almacenesCount = 0;

    if (t.almacen_destino) {
      try {
        const dist = JSON.parse(t.almacen_destino);
        for (const alm of dist) {
          await this._agregarAlmacenForm(true);
          const almIdx = this._almacenesCount - 1;
          const almSelect = document.querySelector(`[name="dist_almacen_f_${almIdx}"]`);
          if (almSelect) almSelect.value = alm.almacen;
          const almCant = document.querySelector(`[name="dist_cantidad_f_${almIdx}"]`);
          if (almCant) almCant.value = alm.cantidad;
        }
        this._validarDistribucionForm();
      } catch (e) { /* ignore */ }
    }
  },

  // ─── TEMPLATE DE LA TABLA ────────────────────────────────
  _renderTablaTractores(readonly = false) {
    const count = this._tractores.length;
    // B5c: en un pedido ya cerrado se ve cuántas unidades de cada renglón llegaron y cuántas faltan
    const conRecepcion = readonly && this._conRecepcion;
    const colspan = (readonly ? 7 : 8) + (conRecepcion ? 2 : 0);

    let rows = '';
    if (count === 0) {
      rows = `
        <tr>
          <td colspan="${colspan}" style="text-align: center; padding: 2.5rem 1rem; color: var(--gray-400);">
            <div>${readonly ? 'Sin equipos registrados' : 'Aún no hay equipos — haz clic en <strong>"+ Agregar equipo"</strong> para comenzar'}</div>
          </td>
        </tr>
      `;
    } else {
      rows = this._tractores.map((t, i) => {
        const subtotal = (t.precio_unitario || 0) * (t.cantidad || 0);
        let almacenesText = '';
        if (t.almacen_destino) {
          try {
            const dist = JSON.parse(t.almacen_destino);
            almacenesText = dist.map(d => `${d.almacen} (${d.cantidad})`).join(' · ');
          } catch (e) { /* ignore */ }
        }
        const accionesDesktop = readonly ? '' : `
            <td class="tbl-hide-mobile">
              <div style="display: flex; gap: 0.5rem; justify-content: center;">
                <button type="button" class="btn btn-sm btn-primary" onclick="window.pedidoDetalleView._editarTractor(${i})">Editar</button>
                <button type="button" class="btn btn-sm btn-danger" onclick="window.pedidoDetalleView._eliminarTractor(${i})">Eliminar</button>
              </div>
            </td>`;
        const accionesMovil = readonly ? '' : `
                <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs);">
                  <button type="button" class="btn btn-sm btn-primary" onclick="window.pedidoDetalleView._editarTractor(${i})">Editar</button>
                  <button type="button" class="btn btn-sm btn-danger" onclick="window.pedidoDetalleView._eliminarTractor(${i})">Eliminar</button>
                </div>`;
        return `
          <tr onmouseover="this.style.background='var(--gray-50)'" onmouseout="this.style.background=''">
            <td><button type="button" class="tbl-expand-btn" onclick="event.stopPropagation(); window.pedidoDetalleView._toggleTractorRow(${i})">&#9654;</button></td>
            <td>
              <div style="font-weight: 600;">${t.marca} · ${t.modelo}</div>
            </td>
            <td class="tbl-hide-mobile">${t.nombre_invoice || '-'}</td>
            <td class="tbl-hide-mobile" style="text-align: center;">${t.cantidad}</td>
            <td class="tbl-hide-mobile" style="text-align: right;">${t.precio_unitario ? '$' + parseFloat(t.precio_unitario).toLocaleString('en-US', {minimumFractionDigits: 2}) : '-'}</td>
            <td class="tbl-hide-mobile" style="text-align: right; font-weight: 600;">$${subtotal.toLocaleString('en-US', {minimumFractionDigits: 2})}</td>
            ${conRecepcion ? `
            <td class="tbl-hide-mobile" style="text-align: center;">${t.recibidas || 0}</td>
            <td class="tbl-hide-mobile" style="text-align: center;">${Number(t.por_recibir) ? `<strong style="color: var(--warning, #b45309);">${t.por_recibir}</strong>` : '0'}</td>` : ''}
            ${accionesDesktop}
          </tr>
          <tr class="tbl-detail-row" id="detail-tractor-${i}">
            <td colspan="${colspan}" class="tbl-detail-cell">
              <!-- Desktop: solo almacenes -->
              <div class="ped-detail-desktop">
                ${almacenesText ? `<div style="font-size: 0.8rem;"><span style="color: var(--gray-500);">Almacenes</span> <span style="color: var(--gray-600);">📦 ${almacenesText}</span></div>` : '<div style="font-size: 0.8rem; color: var(--gray-400);">Sin almacenes asignados</div>'}
              </div>
              <!-- Móvil: datos completos -->
              <div class="ped-detail-mobile" style="font-size: 0.8rem;">
                <div style="display: flex; flex-direction: column; gap: 0.3rem;">
                  <div><span style="color: var(--gray-500);">Cant.</span> <strong>${t.cantidad}</strong></div>
                  <div><span style="color: var(--gray-500);">Precio U.</span> <strong>${t.precio_unitario ? '$' + parseFloat(t.precio_unitario).toLocaleString('en-US', {minimumFractionDigits: 2}) : '-'}</strong></div>
                  <div><span style="color: var(--gray-500);">Subtotal</span> <strong>$${subtotal.toLocaleString('en-US', {minimumFractionDigits: 2})}</strong></div>
                  ${conRecepcion ? `<div><span style="color: var(--gray-500);">Recibidas</span> <strong>${t.recibidas || 0}</strong> · <span style="color: var(--gray-500);">Por recibir</span> <strong>${t.por_recibir || 0}</strong></div>` : ''}
                  ${t.nombre_invoice ? `<div><span style="color: var(--gray-500);">Nombre Invoice</span> <strong>${t.nombre_invoice}</strong></div>` : ''}
                </div>
                ${almacenesText ? `<div style="margin-top: 0.4rem;"><span style="color: var(--gray-500);">Almacenes</span> <strong style="color: var(--gray-600);">📦 ${almacenesText}</strong></div>` : ''}
                ${accionesMovil}
              </div>
            </td>
          </tr>
        `;
      }).join('');
    }

    return `
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.75rem;">
        <span style="font-size: 0.85rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray-700);">Equipos en esta orden <span style="background: ${count > 0 ? 'rgba(37,99,235,0.1)' : 'var(--gray-200)'}; color: ${count > 0 ? 'var(--primary)' : 'var(--gray-600)'}; padding: 0.2rem 0.6rem; border-radius: 10px; font-size: 0.8rem; margin-left: 0.35rem;">${count}</span></span>
        ${readonly ? '' : `<button type="button" style="font-size: 0.85rem; border: 1px solid var(--gray-300); background: white; padding: 0.45rem 1rem; border-radius: 8px; cursor: pointer; color: var(--gray-700); font-weight: 600; transition: border-color 0.2s, color 0.2s;" onmouseover="this.style.borderColor='var(--primary)'; this.style.color='var(--primary)';" onmouseout="this.style.borderColor='var(--gray-300)'; this.style.color='var(--gray-700)';" onclick="window.pedidoDetalleView._abrirModalTractor()">+ Agregar equipo</button>`}
      </div>
      <div class="table-container" style="border: 1px solid var(--gray-200); border-radius: 8px; overflow: hidden;">
        <table class="table ped-tabla-tractores" style="margin: 0;">
          <thead>
            <tr>
              <th></th>
              <th>Equipo</th>
              <th class="tbl-hide-mobile">Nombre Invoice</th>
              <th class="tbl-hide-mobile" style="text-align: center;">Cant.</th>
              <th class="tbl-hide-mobile" style="text-align: right;">Precio U.</th>
              <th class="tbl-hide-mobile" style="text-align: right;">Subtotal</th>
              ${conRecepcion ? '<th class="tbl-hide-mobile" style="text-align: center;">Recibidas</th><th class="tbl-hide-mobile" style="text-align: center;">Por recibir</th>' : ''}
              ${readonly ? '' : '<th class="tbl-hide-mobile" style="text-align: center;">Acciones</th>'}
            </tr>
          </thead>
          <tbody>
            ${rows}
          </tbody>
        </table>
      </div>
    `;
  },

  _refreshTabla() {
    const section = document.getElementById('tablaTractoresSection');
    if (section) section.innerHTML = this._renderTablaTractores();
    this._actualizarTotalGeneral();
  },

  _toggleTractorRow(index) {
    const detailRow = document.getElementById(`detail-tractor-${index}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  // ─── SETUP DEL FORMULARIO ────────────────────────────────
  async _setupFormTractor() {
    const marcaSelect = document.getElementById('marca_f');
    const modeloSelect = document.getElementById('modelo_f');
    const costoInput = document.getElementById('costo_f');

    // Cargar marcas
    try {
      const response = await modeloService.obtenerMarcas();
      const marcas = response.data?.marcas || response.marcas || [];
      marcaSelect.innerHTML = `
        <option value="">— Selecciona —</option>
        ${marcas.map(m => `<option value="${m}">${m}</option>`).join('')}
      `;
    } catch (error) {
      console.error('Error al cargar marcas:', error);
    }

    // Marca → Modelo
    marcaSelect.addEventListener('change', async (e) => {
      const marca = e.target.value;
      if (!marca) {
        modeloSelect.disabled = true;
        modeloSelect.innerHTML = '<option value="">— Selecciona marca primero —</option>';
        if (costoInput) costoInput.value = '';
        return;
      }
      try {
        modeloSelect.disabled = true;
        modeloSelect.innerHTML = '<option value="">Cargando...</option>';
        const response = await modeloService.obtenerPorMarca(marca);
        const modelos = response.data?.modelos || response.modelos || [];
        modeloSelect.innerHTML = `
          <option value="">— Selecciona modelo —</option>
          ${modelos.map(m => `
            <option value="${m.nombre}" data-modelo='${JSON.stringify(m)}'>
              ${m.codigo} - ${m.nombre}${m.linea ? ` · ${m.linea}` : ''}
            </option>
          `).join('')}
        `;
        modeloSelect.disabled = false;
      } catch (error) {
        console.error('Error al cargar modelos:', error);
        modeloSelect.innerHTML = '<option value="">Error al cargar</option>';
      }
    });

    // Modelo → Limpiar campos, auto-rellenar precio y verificar duplicado
    modeloSelect.addEventListener('change', (e) => {
      const anioInput = document.querySelector('[name="detalle_anio_f"]');
      const invoiceInput = document.querySelector('[name="detalle_invoice_f"]');
      const obsInput = document.querySelector('[name="detalle_obs_f"]');

      if (anioInput) anioInput.value = new Date().getFullYear();
      if (invoiceInput) invoiceInput.value = '';
      if (obsInput) obsInput.value = '';
      if (costoInput) costoInput.value = '';

      const selectedOption = e.target.selectedOptions[0];
      if (!selectedOption || !selectedOption.value) return;

      try {
        const modeloData = JSON.parse(selectedOption.dataset.modelo);
        if (modeloData.precio_base && costoInput) costoInput.value = modeloData.precio_base;
      } catch (error) {
        console.error('Error al parsear modelo:', error);
      }

      // Verificar duplicado al seleccionar modelo
      if (this._editingIndex === null) {
        const marca = marcaSelect.value;
        const modelo = e.target.value;
        if (marca && modelo) {
          const duplicado = this._tractores.find(t => t.marca === marca && t.modelo === modelo);
          if (duplicado) {
            const overlay = document.createElement('div');
            overlay.style.cssText = 'position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.4); z-index: 1050; display: flex; align-items: center; justify-content: center;';
            overlay.innerHTML = `
              <div style="background: white; border-radius: 12px; padding: 1.5rem; max-width: 400px; width: 90%; box-shadow: 0 10px 25px rgba(0,0,0,0.15);">
                <h4 style="margin: 0 0 0.75rem; color: var(--gray-800);">Modelo duplicado</h4>
                <p style="margin: 0 0 1.25rem; color: var(--gray-600); font-size: 0.9rem;"><strong>${marca} · ${modelo}</strong> ya está en la lista.<br>¿Desea continuar de todas formas?</p>
                <div style="display: flex; justify-content: flex-end; gap: 0.5rem;">
                  <button type="button" class="btn btn-secondary" id="dupCancel">Cambiar modelo</button>
                  <button type="button" class="btn btn-primary" id="dupConfirm">Sí, continuar</button>
                </div>
              </div>
            `;
            document.body.appendChild(overlay);
            overlay.querySelector('#dupCancel').onclick = () => {
              overlay.remove();
              modeloSelect.value = '';
              if (costoInput) costoInput.value = '';
            };
            overlay.querySelector('#dupConfirm').onclick = () => {
              overlay.remove();
            };
          }
        }
      }
    });

    // Agregar primer almacén
    this._almacenesCount = 0;
    await this._agregarAlmacenForm(true);
  },

  // ─── ALMACENES DEL FORMULARIO ────────────────────────────
  async _agregarAlmacenForm(force = false) {
    if (!this._almacenes) await this._cargarAlmacenes();

    const cantidadTotal = parseInt(document.querySelector('[name="detalle_cantidad_f"]')?.value) || 0;
    const container = document.getElementById('almacenes_f');
    if (!container) return;

    let asignados = 0;
    container.querySelectorAll('[name^="dist_cantidad_f_"]').forEach(input => {
      asignados += parseInt(input.value) || 0;
    });

    if (!force && asignados >= cantidadTotal) {
      toast.warning('Ya se asignaron todos los equipos');
      return;
    }

    if (!force) {
      let sinSeleccionar = false;
      container.querySelectorAll('[name^="dist_almacen_f_"]').forEach(select => {
        if (!select.value) sinSeleccionar = true;
      });
      if (sinSeleccionar) {
        toast.warning('Seleccione el almacén anterior antes de agregar otro');
        return;
      }
    }

    const almacenesUsados = [];
    container.querySelectorAll('[name^="dist_almacen_f_"]').forEach(select => {
      if (select.value) almacenesUsados.push(select.value);
    });

    const almacenesDisponibles = (this._almacenes || []).filter(a => !almacenesUsados.includes(a.nombre));
    if (almacenesDisponibles.length === 0) {
      toast.warning('No hay más almacenes disponibles');
      return;
    }

    const almIdx = this._almacenesCount++;
    const restantes = Math.max(1, cantidadTotal - asignados);
    const almNum = container.querySelectorAll('.ped-almacen-row').length + 1;

    const div = document.createElement('div');
    div.id = `almacen_f_${almIdx}`;
    div.className = 'ped-alm-row';
    div.style.cssText = 'display: grid; grid-template-columns: 30px 1fr 1fr 40px; gap: 0.5rem; align-items: center; padding: 0.5rem 0.25rem; border-bottom: 1px solid var(--gray-100);';
    div.innerHTML = `
      <span class="ped-alm-num" style="font-size: 0.85rem; color: var(--gray-500); font-weight: 600;">${almNum}</span>
      <div class="ped-alm-field">
        <label class="ped-alm-label">Almacén</label>
        <select name="dist_almacen_f_${almIdx}" class="form-select" style="font-size: 0.85rem; width: 100%;">
          <option value="">Seleccione almacén...</option>
          ${almacenesDisponibles.map(a => `<option value="${a.nombre}">${a.nombre}</option>`).join('')}
        </select>
      </div>
      <div class="ped-alm-field">
        <label class="ped-alm-label">Cantidad</label>
        <input type="number" name="dist_cantidad_f_${almIdx}" class="form-input" min="1" max="${restantes}" value="${restantes}" style="text-align: center; font-size: 0.85rem; width: 100%;" onchange="window.pedidoDetalleView._validarDistribucionForm(this)" />
      </div>
      <button type="button" onclick="window.pedidoDetalleView._quitarAlmacenForm(${almIdx})" style="background: none; border: 1px solid var(--gray-300); border-radius: 6px; color: var(--gray-500); cursor: pointer; font-size: 1rem; width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; transition: color 0.2s, border-color 0.2s;" onmouseover="this.style.color='var(--danger)'; this.style.borderColor='var(--danger)';" onmouseout="this.style.color='var(--gray-500)'; this.style.borderColor='var(--gray-300)';">&times;</button>
    `;
    container.appendChild(div);

    div.querySelector('select').addEventListener('change', (e) => {
      const seleccionado = e.target.value;
      if (seleccionado) {
        let repetido = false;
        container.querySelectorAll('[name^="dist_almacen_f_"]').forEach(s => {
          if (s !== e.target && s.value === seleccionado) repetido = true;
        });
        if (repetido) {
          toast.warning('Este almacén ya está asignado.');
          e.target.value = '';
        }
      }
      this._validarDistribucionForm();
    });

    this._validarDistribucionForm();
  },

  _cambiarCantidadAlmacenForm(almIdx, delta) {
    const input = document.querySelector(`[name="dist_cantidad_f_${almIdx}"]`);
    if (!input) return;
    input.value = Math.max(1, (parseInt(input.value) || 1) + delta);
    input.dispatchEvent(new Event('change', { bubbles: true }));
    this._validarDistribucionForm();
  },

  _quitarAlmacenForm(almIdx) {
    const el = document.getElementById(`almacen_f_${almIdx}`);
    if (el) el.remove();
    this._renumerarAlmacenesForm();
    this._validarDistribucionForm();
  },

  _renumerarAlmacenesForm() {
    const container = document.getElementById('almacenes_f');
    if (!container) return;
    container.querySelectorAll('[id^="almacen_f_"]').forEach((row, i) => {
      const num = row.querySelector('span');
      if (num) num.textContent = i + 1;
    });
  },

  _onFormCantidadChange() {
    this._validarDistribucionForm();
  },

  _validarDistribucionForm(changedInput = null) {
    const cantidadTotal = parseInt(document.querySelector('[name="detalle_cantidad_f"]')?.value) || 0;
    const container = document.getElementById('almacenes_f');
    if (!container) return;

    const inputs = container.querySelectorAll('[name^="dist_cantidad_f_"]');

    // Solo limitar el campo que cambió (no tocar los demás)
    if (changedInput) {
      let otros = 0;
      inputs.forEach(other => { if (other !== changedInput) otros += parseInt(other.value) || 0; });
      const maxPermitido = Math.max(1, cantidadTotal - otros);
      changedInput.max = maxPermitido;
      if (parseInt(changedInput.value) > maxPermitido) {
        changedInput.value = maxPermitido;
      }
    }

    let asignados = 0;
    inputs.forEach(input => { asignados += parseInt(input.value) || 0; });

    // Botón agregar almacén
    const btnAgregar = document.getElementById('btnAgregarAlmacen_f');
    if (btnAgregar) {
      const disabled = asignados >= cantidadTotal;
      btnAgregar.disabled = disabled;
      btnAgregar.style.opacity = disabled ? '0.4' : '1';
      btnAgregar.style.cursor = disabled ? 'not-allowed' : 'pointer';
    }

    // Verificar si todos los almacenes están seleccionados
    let todosSeleccionados = true;
    container.querySelectorAll('[name^="dist_almacen_f_"]').forEach(s => {
      if (!s.value) todosSeleccionados = false;
    });

    const completo = asignados === cantidadTotal && cantidadTotal > 0 && todosSeleccionados;

    // Counter y barra
    const counterEl = document.getElementById('almacenCounter_f');
    if (counterEl) {
      counterEl.textContent = `${asignados} / ${cantidadTotal}`;
      counterEl.style.color = completo ? 'var(--success)' : asignados > cantidadTotal ? '#dc3545' : '#f59e0b';
    }

    const barEl = document.getElementById('almacenBar_f');
    if (barEl) {
      const pct = cantidadTotal > 0 ? Math.min(100, (asignados / cantidadTotal) * 100) : 0;
      barEl.style.width = `${pct}%`;
      barEl.style.background = completo ? 'var(--success)' : asignados > cantidadTotal ? '#dc3545' : '#f59e0b';
    }

    // Warning
    const warning = document.getElementById('almacenWarning_f');
    if (warning) {
      if (asignados > cantidadTotal) {
        warning.style.display = 'block';
        warning.style.background = 'rgba(220,53,69,0.08)';
        warning.style.color = '#dc3545';
        warning.innerHTML = `Excede en ${asignados - cantidadTotal} unidades`;
      } else if (asignados < cantidadTotal && asignados > 0) {
        warning.style.display = 'block';
        warning.style.background = 'rgba(245,158,11,0.08)';
        warning.style.color = '#f59e0b';
        warning.innerHTML = `Faltan ${cantidadTotal - asignados} unidades por asignar`;
      } else if (asignados === cantidadTotal && cantidadTotal > 0) {
        if (completo) {
          warning.style.display = 'block';
          warning.style.background = 'rgba(16,185,129,0.08)';
          warning.style.color = 'var(--success)';
          warning.innerHTML = '✓ Asignación completa';
        } else {
          warning.style.display = 'block';
          warning.style.background = 'rgba(245,158,11,0.08)';
          warning.style.color = '#f59e0b';
          warning.innerHTML = 'Seleccione el almacén en todas las filas';
        }
      } else {
        warning.style.display = 'none';
      }
    }
  },

  // ─── RECOPILAR DISTRIBUCIÓN DEL FORM ─────────────────────
  _recopilarDistribucionForm() {
    const container = document.getElementById('almacenes_f');
    if (!container) return null;
    const distribucion = [];
    container.querySelectorAll('[name^="dist_almacen_f_"]').forEach(select => {
      const almacen = select.value;
      const suffix = select.name.replace('dist_almacen_f_', '');
      const cantInput = container.querySelector(`[name="dist_cantidad_f_${suffix}"]`);
      const cantidad = parseInt(cantInput?.value) || 0;
      if (almacen && cantidad > 0) {
        distribucion.push({ almacen, cantidad });
      }
    });
    return distribucion.length > 0 ? JSON.stringify(distribucion) : null;
  },

  // ─── AGREGAR TRACTOR A LA LISTA ──────────────────────────
  _agregarALista() {
    const marca = document.getElementById('marca_f')?.value;
    const modelo = document.getElementById('modelo_f')?.value;

    if (!marca) { toast.error('Debe seleccionar una marca'); return; }
    if (!modelo) { toast.error('Debe seleccionar un modelo'); return; }

    const cantidad = parseInt(document.querySelector('[name="detalle_cantidad_f"]')?.value) || 1;
    const precioUnit = parseFloat(document.getElementById('costo_f')?.value) || 0;

    if (precioUnit <= 0) { toast.error('Debe ingresar el precio unitario'); return; }

    // Validar almacenes — revisar todas las filas antes de recopilar
    const almContainer = document.getElementById('almacenes_f');
    const allSelects = almContainer ? almContainer.querySelectorAll('[name^="dist_almacen_f_"]') : [];
    if (allSelects.length === 0) { toast.error('Debe asignar al menos un almacén'); return; }

    let sinSeleccionar = false;
    allSelects.forEach(s => { if (!s.value) sinSeleccionar = true; });
    if (sinSeleccionar) { toast.error('Seleccione el almacén en todas las filas'); return; }

    const distribucion = this._recopilarDistribucionForm();
    const dist = distribucion ? JSON.parse(distribucion) : [];

    const totalAsignado = dist.reduce((sum, d) => sum + d.cantidad, 0);
    if (totalAsignado !== cantidad) {
      toast.error(`Almacenes asignados (${totalAsignado}) no coincide con la cantidad (${cantidad})`);
      return;
    }

    const tractor = {
      marca,
      modelo,
      cantidad,
      anio: parseInt(document.querySelector('[name="detalle_anio_f"]')?.value) || null,
      precio_unitario: precioUnit,
      subtotal: precioUnit * cantidad,
      nombre_invoice: document.querySelector('[name="detalle_invoice_f"]')?.value || null,
      observaciones: document.querySelector('[name="detalle_obs_f"]')?.value || null,
      almacen_destino: distribucion,
      _completo: true
    };

    if (this._editingIndex !== null) {
      if (this._tractores[this._editingIndex]?.id) {
        tractor.id = this._tractores[this._editingIndex].id;
      }
      this._tractores[this._editingIndex] = tractor;
      toast.success('Equipo actualizado');
      this._editingIndex = null;
    } else {
      this._tractores.push(tractor);
      toast.success('Equipo agregado');
    }

    modal.close();
    this._refreshTabla();
    this._marcarCambiosPedido();
  },

  // ─── EDITAR TRACTOR ──────────────────────────────────────
  _editarTractor(index) {
    this._abrirModalTractor(index);
  },

  // ─── ELIMINAR TRACTOR ────────────────────────────────────
  _eliminarTractor(index) {
    this._tractores.splice(index, 1);
    this._refreshTabla();
    this._marcarCambiosPedido();
    toast.success('Equipo eliminado');
  },

  // ─── INDICADOR DE CAMBIOS SIN GUARDAR (solo edición) ─────
  _marcarCambiosPedido() {
    if (!this._isEditMode) return;
    const indicator = document.getElementById('unsavedIndicatorPedido');
    if (indicator) indicator.style.display = 'block';
  },

  _ocultarCambiosPedido() {
    const indicator = document.getElementById('unsavedIndicatorPedido');
    if (indicator) indicator.style.display = 'none';
  },

  // ─── CARGAR ALMACENES ────────────────────────────────────
  async _cargarAlmacenes() {
    try {
      const response = await api.get('/almacenes/activos');
      this._almacenes = response.data?.almacenes || response.almacenes || [];
    } catch (error) {
      console.error('Error al cargar almacenes:', error);
      this._almacenes = [];
    }
  },

  // ─── TOTAL GENERAL ───────────────────────────────────────
  _actualizarTotalGeneral() {
    let total = 0;
    this._tractores.forEach(t => { total += (t.precio_unitario || 0) * (t.cantidad || 0); });
    const moneda = document.querySelector('[name="moneda"]')?.value || 'USD';
    const totalEl = document.getElementById('totalGeneralPedido');
    if (totalEl) totalEl.textContent = `Total est.: $${total.toLocaleString('en-US', {minimumFractionDigits: 2})} ${moneda}`;
  },

  // ─── GUARDAR NUEVO ───────────────────────────────────────
  async guardarNuevo() {
    const proveedorId = document.querySelector('[name="proveedor_id"]')?.value;
    if (!proveedorId) { toast.error('Debe seleccionar un proveedor'); return; }

    if (this._tractores.length === 0) {
      toast.error('Debe agregar al menos un equipo a la lista');
      return;
    }

    let total = 0;
    const detalles = this._tractores.map(t => {
      const subtotal = (t.precio_unitario || 0) * (t.cantidad || 0);
      total += subtotal;
      return {
        marca: t.marca,
        modelo: t.modelo,
        cantidad: t.cantidad,
        anio: t.anio,
        precio_unitario: t.precio_unitario,
        subtotal,
        observaciones: t.observaciones,
        nombre_invoice: t.nombre_invoice,
        almacen_destino: t.almacen_destino
      };
    });

    const data = {
      proveedor_id: parseInt(proveedorId),
      moneda: document.querySelector('[name="moneda"]')?.value || 'USD',
      subtotal: total,
      total,
      detalles
    };

    try {
      const response = await api.post('/pedidos-compra', data);
      toast.success('Pedido creado exitosamente');
      const pedido = response.data?.pedido || response.pedido || response.data;
      router.navigate(`/compras/pedidos/${pedido.id}`);
    } catch (error) {
      toast.error(error.message || 'Error al crear pedido');
      console.error(error);
    }
  },

  // ─── PEDIDO EXISTENTE ────────────────────────────────────
  async renderPedidoExistente() {
    const container = document.getElementById('pedidoContent');
    if (!container) return;
    const p = this.data.pedido;

    const badgeEstado = (estado) => {
      const colors = {
        'pendiente': 'badge-warning', 'emitida': 'badge-primary',
        'confirmada': 'badge-info', 'en_transito': 'badge-warning',
        'recibida': 'badge-success', 'cancelada': 'badge-danger'
      };
      const labels = {
        'pendiente': 'Pendiente', 'emitida': 'Emitida',
        'confirmada': 'Confirmada', 'en_transito': 'En Tránsito',
        'recibida': 'Recibida', 'cancelada': 'Cancelada'
      };
      return `<span class="badge ${colors[estado] || ''}">${labels[estado] || estado}</span>`;
    };

    const formatFecha = (f) => {
      if (!f) return '-';
      return f.substring(0, 10).split('-').reverse().join('/');
    };

    const isEditable = p.estado === 'pendiente';
    this._isEditMode = isEditable;
    // B5c: la recepción sólo aplica a pedidos cerrados por Compras (Almacén no ve los «pendiente»)
    this._conRecepcion = !isEditable && p.estado === 'completa';
    const rec = p.recepcion || { recibidas: 0, por_recibir: 0 };
    const totalUnidades = (p.detalles || []).reduce((a, d) => a + (Number(d.cantidad) || 0), 0);
    const botonesFlujo = this._conRecepcion ? [
      permisos.canView('recepciones')
        ? `<button type="button" class="btn ${rec.por_recibir > 0 ? 'btn-primary' : 'btn-secondary'}" onclick="router.navigate('/almacen/recepciones/pedido/${p.id}')">${rec.por_recibir > 0 ? '📦 Recibir unidades' : '📦 Ver recepción'}</button>`
        : '',
      permisos.canView('compras') && rec.recibidas > 0
        ? `<button type="button" class="btn btn-secondary" onclick="router.navigate('/compras/facturas?pedido=${p.id}')">🧾 Factura del proveedor</button>`
        : ''
    ].join('') : '';

    // Cargar tractores desde BD al array interno
    this._tractores = (p.detalles || []).map(d => ({
      id: d.id,
      marca: d.marca,
      modelo: d.modelo,
      cantidad: d.cantidad || 1,
      anio: d.anio,
      recibidas: Number(d.recibidas) || 0,
      por_recibir: Number(d.por_recibir) || 0,
      precio_unitario: parseFloat(d.precio_unitario) || 0,
      subtotal: parseFloat(d.subtotal) || 0,
      nombre_invoice: d.nombre_invoice,
      observaciones: d.observaciones,
      almacen_destino: d.almacen_destino,
      _completo: !!(d.marca && d.modelo && parseFloat(d.precio_unitario) > 0)
    }));

    container.innerHTML = `
      <!-- Datos de Orden -->
      <div style="border: 1px solid var(--gray-200); border-radius: 8px; padding: 1.25rem; margin-bottom: 1.5rem;">
        ${this._sectionTitle('Datos de Orden')}
        <div class="ped-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem;">
          <div>
            <label style="${this._labelStyle()}">Folio</label>
            <input type="text" class="form-input" readonly style="background: var(--gray-50);" value="${p.folio}" />
          </div>
          <div>
            <label style="${this._labelStyle()}">Fecha</label>
            <input type="text" class="form-input" readonly style="background: var(--gray-50);" value="${formatFecha(p.fecha_pedido)}" />
          </div>
        </div>
        <div class="ped-grid-2col" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem; margin-top: 0.5rem;">
          <div>
            <label style="${this._labelStyle()}">Proveedor</label>
            <input type="text" class="form-input" readonly style="background: var(--gray-50);" value="${p.proveedor_nombre || '-'}" />
          </div>
          <div>
            <label style="${this._labelStyle()}">Moneda</label>
            <input type="text" name="moneda" class="form-input" readonly style="background: var(--gray-50);" value="${p.moneda || 'USD'}" />
          </div>
        </div>
      </div>

      ${isEditable ? `
        <!-- Tabla de tractores -->
        <div id="tablaTractoresSection" style="margin-bottom: 1.5rem;">
          ${this._renderTablaTractores()}
        </div>

        <!-- Indicador de cambios sin guardar -->
        <div id="unsavedIndicatorPedido" style="display: none; background: var(--warning); color: white; padding: 0.5rem 1rem; border-radius: 8px; margin-bottom: 1rem; text-align: center; font-size: 0.85rem; font-weight: 600;">
          Hay cambios sin guardar
        </div>

        <!-- Footer -->
        <div class="ped-footer-acciones" style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 1rem;">
          <div id="totalGeneralPedido" style="background: #E6F1FB; color: var(--primary); padding: 0.5rem 1rem; border-radius: 8px; font-size: 0.9rem; font-weight: 600;">
            Total est.: $${(p.total || 0).toLocaleString('en-US', {minimumFractionDigits: 2})} ${p.moneda || 'USD'}
          </div>
          <div style="display: flex; gap: 0.75rem;">
            <button type="button" class="btn btn-secondary" onclick="router.navigate('/compras/pedidos')">Cancelar</button>
            <button type="button" class="btn btn-success" onclick="window.pedidoDetalleView.guardarEdicion(${p.id})">Guardar cambios</button>
            ${permisos.can('ordenes_compra', 'cerrar') ? `
              <button type="button" class="btn btn-primary" onclick="window.pedidoDetalleView.cambiarEstado(${p.id}, 'completa')">Completar orden</button>
            ` : ''}
          </div>
        </div>
      ` : `
        <!-- Tractores readonly -->
        <div style="margin-bottom: 1.5rem;">
          ${this._renderTablaTractores(true)}
        </div>

        <!-- Total -->
        <div class="ped-footer-acciones" style="display: flex; justify-content: flex-end; align-items: center; flex-wrap: wrap; gap: 1rem;">
          ${this._conRecepcion ? `
          <div id="pedidoRecepcionResumen" style="margin-right: auto; display: flex; align-items: center; gap: 0.75rem; flex-wrap: wrap;">
            <span style="font-size: 0.9rem; color: var(--gray-700);">Recibidas: <strong>${rec.recibidas}</strong> de ${totalUnidades} · Por recibir: <strong>${rec.por_recibir}</strong></span>
            ${botonesFlujo}
          </div>` : ''}
          <div style="background: #E6F1FB; color: var(--primary); padding: 0.5rem 1rem; border-radius: 8px; font-size: 0.9rem; font-weight: 600;">
            Total: $${(p.total || p.detalles.reduce((sum, d) => sum + (parseFloat(d.subtotal) || (parseFloat(d.precio_unitario) || 0) * d.cantidad), 0)).toLocaleString('en-US', {minimumFractionDigits: 2})} ${p.moneda || 'USD'}
          </div>
        </div>
      `}
    `;

    if (isEditable) {
      await this._cargarAlmacenes();
    }
  },

  // ─── GUARDAR EDICIÓN ─────────────────────────────────────
  async guardarEdicion(id) {
    if (this._tractores.length === 0) {
      toast.error('Debe tener al menos un equipo');
      return;
    }

    let total = 0;
    const detalles = this._tractores.map(t => {
      const subtotal = (t.precio_unitario || 0) * (t.cantidad || 0);
      total += subtotal;
      return {
        id: t.id || null,
        marca: t.marca,
        modelo: t.modelo,
        cantidad: t.cantidad,
        anio: t.anio,
        precio_unitario: t.precio_unitario,
        subtotal,
        observaciones: t.observaciones,
        nombre_invoice: t.nombre_invoice,
        almacen_destino: t.almacen_destino
      };
    });

    try {
      await api.put(`/pedidos-compra/${id}`, { subtotal: total, total, detalles });
      toast.success('Pedido actualizado');
      this._ocultarCambiosPedido();
      await this.cargarPedido(id);
    } catch (error) {
      toast.error(error.message || 'Error al actualizar');
      console.error(error);
    }
  },

  // ─── CAMBIAR ESTADO ──────────────────────────────────────
  async cambiarEstado(id, nuevoEstado) {
    if (nuevoEstado === 'completa') {
      // Bloquear si hay cambios sin guardar
      const indicator = document.getElementById('unsavedIndicatorPedido');
      if (indicator && indicator.style.display !== 'none') {
        toast.error('Tiene cambios sin guardar. Presione "Guardar cambios" antes de completar la orden.');
        return;
      }

      // Validar que todos los tractores estén completos
      if (this._tractores.length === 0) {
        toast.error('Debe tener al menos un equipo');
        return;
      }

      for (let i = 0; i < this._tractores.length; i++) {
        const t = this._tractores[i];
        if (!t.marca || !t.modelo) {
          toast.error(`Equipo ${i + 1}: Falta marca o modelo`);
          return;
        }
        if (!t.precio_unitario || t.precio_unitario <= 0) {
          toast.error(`Equipo ${i + 1}: Falta precio unitario`);
          return;
        }
        if (!t.almacen_destino) {
          toast.error(`Equipo ${i + 1}: Falta distribución por almacén`);
          return;
        }
        const dist = JSON.parse(t.almacen_destino);
        const totalAsignado = dist.reduce((sum, d) => sum + d.cantidad, 0);
        if (totalAsignado !== t.cantidad) {
          toast.error(`Equipo ${i + 1}: Almacenes (${totalAsignado}) no coincide con cantidad (${t.cantidad})`);
          return;
        }
      }

      modal.confirm(
        'Completar Orden',
        '¿Está seguro de completar esta orden? Una vez completada no podrá ser editada.',
        async () => {
          try {
            // Guardar primero
            await this.guardarEdicion(id);
            await api.patch(`/pedidos-compra/${id}/estado`, { estado: nuevoEstado });
            toast.success('Orden completada exitosamente');
            await this.cargarPedido(id);
          } catch (error) {
            toast.error(error.message || 'Error al completar orden');
          }
        }
      );
      return;
    }

    modal.confirm(
      'Cambiar Estado',
      '¿Está seguro de cambiar el estado de esta orden?',
      async () => {
        try {
          await api.patch(`/pedidos-compra/${id}/estado`, { estado: nuevoEstado });
          toast.success('Estado actualizado');
          await this.cargarPedido(id);
        } catch (error) {
          toast.error(error.message || 'Error al cambiar estado');
        }
      }
    );
  },

  imprimir() {
    if (!this.data.pedido?.id) return;
    router.navigate(`/compras/pedidos/${this.data.pedido.id}/print`);
  }
};
